export const categories = [
  // { title: "Basics" },
  { title: "CSS / HTML" },
  // { title: "Design" },
  { title: "Javascript" },
  { title: "Random" },
  { title: "React" },
  // { title: "Styling" },
];
